import {Pipe, PipeTransform} from "@angular/core";
import {EntityData} from "@fedeltapointofsale/data-client";

@Pipe({
    name: "property",
    pure: false
})
/**
 * Pipe to access nested properties on a object
 */
export class PropertyPipe implements PipeTransform {
    transform(value: any, args?: string): any {
        return EntityData.getField(value, args);
    }
}
